import React, { useEffect, useRef, useState } from 'react';

const AutoVideo = ({
  src,
  poster,
  className = '',
  videoClassName = '',
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
}) => {
  const wrapperRef = useRef(null);
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const element = wrapperRef.current;
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;
        setIsVisible(visible);

        if (visible) {
          setShouldLoad(true);
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !autoPlay || !shouldLoad) {
      return;
    }

    if (isVisible) {
      const playPromise = video.play();
      if (playPromise?.catch) {
        playPromise.catch(() => {});
      }
      return;
    }

    video.pause();
  }, [autoPlay, isVisible, shouldLoad]);

  return (
    <div ref={wrapperRef} className={className}>
      <video
        ref={videoRef}
        className={videoClassName}
        poster={poster}
        muted={muted}
        loop={loop}
        playsInline={playsInline}
        autoPlay={autoPlay}
        preload="metadata"
      >
        {shouldLoad ? <source src={src} type="video/mp4" /> : null}
      </video>
    </div>
  );
};

export default AutoVideo;
